export const CHANNEL_CONSTS = {
    GET_CHANNELS: "GET_CHANNELS",
    GET_CHANNEL_BY_ID: "GET_CHANNEL_BY_ID",
    ADD_CHANNEL: "ADD_CHANNEL",
    UPDATE_CHANNEL: "UPDATE_CHANNEL",
    UPDATE_CHANNEL_USERS: "UPDATE_CHANNEL_USERS",
    DELETE_CHANNEL: "DELETE_CHANNEL",
};
